import { Component, OnInit } from '@angular/core';
import { ChartType } from 'chart.js';
import { WebServicesService } from 'src/app/container/internal/internal-home/pages/webservices/webservices.service';
import { HomeExternalService } from 'src/app/container/external/shared/home/home-external.service';
import { VistaRapida } from 'src/app/core/entities/vistarapida.models';
import * as _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-donas3',
  templateUrl: './donas.component.html',
  styleUrls: ['./donas.component.scss']
})
export class Donas3Component implements OnInit {

  vistaRapidaActivo: VistaRapida = new VistaRapida();

  factuPag : number = 0;
  factuPen : number = 0;
  factuRech : number = 0;
  factuIncid : number = 0;

  public doughnutChartType: ChartType = 'doughnut';

  public doughnutChartData: any = {
    labels: [] ,
    datasets: [
      {
        data: [0, 0, 0],
        backgroundColor: ['#28a745', '#dc3545', '#fd7e14']
      }
    ]
  };

  public chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
  }

  constructor(private translateService: TranslateService,
              private webServicesService : WebServicesService,
              private homeExternalService: HomeExternalService) { }

  ngOnInit(): void  {
    if(this.webServicesService.vistaRapidaObj.active){
      this.vistaRapidaActivo =  _.cloneDeep(this.webServicesService.vistaRapidaObj);
      this.actualizarGrafico();
    }
    if(this.homeExternalService.vistaRapidaObj.active){
      this.vistaRapidaActivo =  _.cloneDeep(this.homeExternalService.vistaRapidaObj);
      this.actualizarGrafico();
    }
  }

  actualizarGrafico(): void {

    this.doughnutChartData.datasets[0].data = [
      +this.vistaRapidaActivo.factpagat.toFixed(2),
      +this.vistaRapidaActivo.factpende.toFixed(2),
      +this.vistaRapidaActivo.factincid.toFixed(2)
    ];

    this.factuPag = this.vistaRapidaActivo.totFacPag;
    this.factuPen = this.vistaRapidaActivo.totFacPend;
    this.factuIncid = this.vistaRapidaActivo.totFacIncid;

    this.doughnutChartData.labels = [
      this.translateService.instant('WEBSERVICES.VISTA_RAPIDA.FACTURAS.pagado') +
      ': ' + this.factuPag +
      ' - ' +
      this.translateService.instant('TABLAS.importe'),

      this.translateService.instant('WEBSERVICES.VISTA_RAPIDA.FACTURAS.pendiente') +
      ': ' + this.factuPen +
      ' - ' +
      this.translateService.instant('TABLAS.importe'),

      this.translateService.instant('WEBSERVICES.VISTA_RAPIDA.FACTURAS.incidencia') +
      ': ' + this.factuIncid +
      ' - ' +
      this.translateService.instant('TABLAS.importe')
    ];
  }

  //event
  public chartClicked({ event, active }: { event: MouseEvent, active: {}[] }): void {
    //console.log(event, active);
  }

  //event
  public chartHovered({ event, active }: { event: MouseEvent, active: {}[] }): void {
    //console.log(event, active);
  }

}